// removed by extract-text-webpack-plugin
module.exports = {"container":"_2buSvvmYOFpSyHT-k4wogj","icon":"_24z02rX1uc6G6dJzPBfE0f","title":"_176RbhZSNEY-u13eUS0dlQ"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Custom/Main/styles.css
// module id = 3185
// module chunks = 0